import { CommonResultId } from '../common/CommonResultId.js'
import { EventStatusId } from '../EventStatusId.js'
import { ResultId } from '../ResultId.js'
import { SoccerEventStatusId } from './EventStatusId.js'
import { SoccerResultId } from './SoccerResultId.js'

export const soccerStatusResultsMap: {
  [key in EventStatusId]?: ResultId[]
} = {
  [SoccerEventStatusId.FirstHalf]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    SoccerResultId.FirstHalf,
  ],
  [SoccerEventStatusId.SecondHalf]: [
    CommonResultId.Result,
    CommonResultId.RegularTime,
    SoccerResultId.SecondHalf,
  ],
  [SoccerEventStatusId.ExtratimeFirstHalf]: [
    CommonResultId.Result,
    SoccerResultId.ExtratimeFirstHalf,
    CommonResultId.Result,
  ],
  [SoccerEventStatusId.ExtratimeSecondHalf]: [
    CommonResultId.Result,
    SoccerResultId.ExtratimeSecondHalf,
    CommonResultId.Result,
  ],
  [SoccerEventStatusId.PenaltyShootout]: [CommonResultId.Penalty],
}
